__webpack_require__.p = "/AI-Fitness-Frontend/";